import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=1519de95&scoped=true&"
var script = {}
import style0 from "./Back.vue?vue&type=style&index=0&id=1519de95&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1519de95",
  null
  
)

component.options.__file = "Back.vue"
export default component.exports